<template>
  <b-container fluid class="mt-50">
    <b-row class="my-3 justify-content-end">
      <b-col cols="12" md="3">
        <app-select
          :data="{
            options: companies,
            valueDefault: 'Empresa',
            required: true,
          }"
          v-model="companyId"
        />
      </b-col>
      <b-col cols="6" md="3" class="d-flex justify-content-center">
        <b-button variant="secondary" class="w-50">Limpar</b-button>
        <b-button variant="primary" class="ml-1 w-50">Pesquisar</b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <app-table
          :data-array="array"
          :fields="fields"
          title="Lista de Vulnerabilidades"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mixins } from "@/mixins/mixins";
export default {
    metaInfo: {
    title: "Listagem GV",
    titleTemplate: "%s | Odin",
  },
  mixins: [mixins],
  data() {
    return {
      array: [],
      fields: [
        { key: "vune", label: "Vulnerabilidade" },
        { key: "cve", label: "CVE" },
        { key: "sev", label: "Severidade" },
        { key: "qnt_assets", label: "Qtd. Ativos" },
        { key: "auto", label: "Tratativa Automatizada" },
        { key: "actions", label: "Seleção" },
      ],
      companies: [],
      companyId: undefined,
    };
  },
};
</script>

<style>
</style>